export const API_URL = process.env.REACT_APP_API_URL || 'https://why-it-not-exist-backend.onrender.com';

// Test connection function
export const testConnection = async () => {
  try {
    console.log('Attempting to connect to:', `${API_URL}/api/ping`);
    const response = await fetch(`${API_URL}/api/ping`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Response data:', data);
    return data.message === 'pong';
  } catch (error) {
    console.error('Connection test failed:', error);
    return false;
  }
};

export const submitFeedback = async (data) => {
  const apiUrl = `${API_URL}/api/feedback`;
  
  try {
    console.log('Making API request to:', apiUrl);
    console.log('With data:', JSON.stringify(data, null, 2));

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(data)
    });

    // Log the response details
    console.log('Response status:', response.status);
    const responseText = await response.text();
    console.log('Raw response:', responseText);

    if (!response.ok) {
      throw new Error(responseText);
    }

    return response;
  } catch (error) {
    console.error('API Error:', {
      endpoint: apiUrl,
      requestData: data,
      error: error.message
    });
    throw error;
  }
};

export const createCompany = async (companyData) => {
  try {
    const response = await fetch('/api/companies', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: companyData.name,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to create company');
    }

    const newCompany = await response.json();
    return {
      id: newCompany.id,
      name: newCompany.name,
      type: 'existing'
    };
  } catch (error) {
    console.error('Error creating company:', error);
    throw error;
  }
};

export const searchFeedback = async ({ startDate, endDate, type }) => {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());
    if (type) params.append('type', type); // Only 'existing' or 'startup'

    const response = await fetch(
      `${API_URL}/feedback/search?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch feedback');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching feedback:', error);
    throw error;
  }
};

export const handlePostPurchase = async (sessionId) => {
  try {
    const response = await fetch(`${API_URL}/api/stripe/purchase-complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sessionId
      })
    });

    if (!response.ok) {
      throw new Error('Failed to process post-purchase actions');
    }

    return await response.json();
  } catch (error) {
    console.error('Post-purchase error:', error);
    throw error;
  }
}; 